import React, { useEffect, useRef, useState } from "react";
import useApis from "../../services/useAPI";
import { useAuth } from "../../components/AuthContext/AuthContext";
import DynamicForm from "../../stories/Forms/DynamicForm";
import PhoneNumberForm from "../../stories/Forms/PhoneNumberForm";
import { MfaFields, MfaEmailFields, OtpFields } from "../../stories/Forms/fields";
import { mfaSchema, optSchema } from "../../stories/Forms/validationSchema";
import { Spinner } from "react-bootstrap";
import { XSquare, BoxArrowInRight } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { removeCountryCode, removeCountryCodeForUkNumber, getCountryFromPhone } from "../../utils/utils";
const RESEND_INTERVAL = 30; // seconds

/**
 * EnableMFA component facilitates enabling Multi-Factor Authentication (MFA) for the user account.
 */
const EnableMFA = ({ onProceedToOTP , onVerifySuccess, addNumberformikRef, setIsOtpFields}) => {
  const navigate = useNavigate();
  const { callApi: callGetApi, resultGet } = useApis();
  const { callApi: callSubmitApi, resultPost, serverError } = useApis();
  const { callApi: callResendApi, serverError: resendError } = useApis();

  const auth = useAuth();
  const enablemfaFormikRef = useRef(null);
  const url = `/api/dashboard/check-contact/${localStorage.getItem("user_id")}`;
  const postUrl = `/api/dashboard/add-contact/`;
  const postUrl2 = `/api/dashboard/verify-otp`;
  const pagePath =  globalThis.location.pathname;
  const bloodPath = pagePath.split("/").slice(0, 2).join("/");
  const [ph_number, setPh_number] = useState();
  const [ph_number_full, setPh_number_full] = useState();
  const [isUkNumberPrefilled, setIsUkNumberPrefilled] = useState(false);
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [successClass, setSuccessClass] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [otpSentByEmail, setOtpSentByEmail] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [mfaSentEmail, setMfaSentEmail] = useState("");
  const [mfaEmail, setMfaEmail] = useState("");
  const timerRef = useRef(null);
  const [mfaValues, setMfaValues] = useState({
  verifyOtp: "",
  emailMFA: true,
});

  const processedSubmitCountRef = useRef(0);
  const submitAttemptCountRef = useRef(0);
  const [transitioning, setTransitioning] = useState(false);

  const authHeaders = {
    Authorization: `Bearer ${auth.accessToken}`,
    "Content-Type": "application/json"
  };

  const startResendTimer = () => {
    setSecondsLeft(RESEND_INTERVAL);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleMFASubmit = async values => {
    setTransitioning(true);
    if (values.verifyOtp) {
      setMfaValues({
        verifyOtp: values.verifyOtp || "",
        emailMFA: values.emailMFA ?? true,
      });
    }
    const phoneNumber = values.primary_contact_no || "";
  const selectedCountryCode = values.primary_contact_no_country || "+44";

  const countryCode = phoneNumber
    ? `+${getCountryFromPhone(phoneNumber)?.code || ""}`
    : "";

 // Numbers from the international input already include their country code
 const mobile = !phoneNumber
  ? ""
  : phoneNumber.startsWith("+") || countryCode === selectedCountryCode
    ? phoneNumber
    : `${selectedCountryCode}${phoneNumber}`;

    const data = values.verifyOtp
    ? {
        otp: values.verifyOtp,
        user_id: localStorage.getItem("user_id"),
        email_mfa: values.emailMFA === true
    }
    : {
        mobile ,
        user_id: localStorage.getItem("user_id"),
        email_mfa: values.emailMFA === true
    };
    // Keep the entered number for resend (field may have started blank)
    if (mobile) setPh_number(removeCountryCode(mobile));
    const submitUrl = values.verifyOtp ? postUrl2 : postUrl;
    if(submitUrl === "/api/dashboard/add-contact/" && values.emailMFA === true){
        setOtpSentByEmail(true);
    }
    submitAttemptCountRef.current += 1;
    const response = await callSubmitApi(data, submitUrl, "POST", authHeaders);
    if(response){
      setMfaSentEmail(response?.email)
    }
    if (response && !values.verifyOtp && !isOtpStage) {
      advanceToOtpStage();
    }
  };
  const handleResendOtp = async () => {
    if (resendLoading || secondsLeft > 0 || (!ph_number && !auth?.isNonUKNumber)) return;
    setResendLoading(true);    
    try {
      await callResendApi(
        { mobile: ph_number, user_id: localStorage.getItem("user_id"), email_mfa: auth?.isNonUKNumber},
        postUrl,
        "POST",
        authHeaders
      );
      startResendTimer();
    } finally {
      setResendLoading(false);
    }
  };

  const advanceToOtpStage = () => {
    setIsOtpStage(true);
    setIsOtpFields(true);
    startResendTimer();
    if(onProceedToOTP){ 
      onProceedToOTP();
    }
  };

  useEffect(() => {
    callGetApi(null, url, "GET", authHeaders);
  }, []);

useEffect(() => {
  if (!resultGet) return;
  auth.setIsNonUKNumber(false);
  if (resultGet.primary_contact_no) {
    const raw = resultGet.primary_contact_no.trim();
    const ukPrefix = resultGet.uk_prefix_exist;
    setPh_number(ukPrefix ? removeCountryCode(raw) : "");
    setIsUkNumberPrefilled(Boolean(ukPrefix && raw));
    setPh_number_full(raw);
    auth.setPrimaryPhoneNumber(raw);
  }
}, [resultGet]);

 
  useEffect(() => {
    setTransitioning(false);
    if (resultPost?.message === "OTP verified successfully.") {
    auth.showToast(
      "Success",
      resultPost?.message,
      "../assets/mhc.png",
      <BoxArrowInRight />
    );
    setSuccessClass(true);
    setTimeout(() => {
      onVerifySuccess && onVerifySuccess();
      if (bloodPath === "/bloods") {
        navigate("/appointments");
      }
    }, 1000);
    localStorage.setItem("mfa_enabled",true)
    sessionStorage.setItem("email_mfa",true)
    return;
  }
    if (
      resultPost &&
      !isOtpStage &&
      processedSubmitCountRef.current < submitAttemptCountRef.current
    ) {
      processedSubmitCountRef.current = submitAttemptCountRef.current;
      advanceToOtpStage();
    }
  }, [resultPost]);

 useEffect(() => {
  setTransitioning(false);
  const isEmpty =
    serverError === null ||
    serverError === undefined ||
    serverError === '' ||
    (typeof serverError === 'object' && Object.keys(serverError).length === 0);

  if (!isEmpty) {
    auth.showToast(
      "Error",
      serverError,
      "../assets/mhc.png",
      <XSquare />
    );
  }
}, [serverError]);



  useEffect(() => {
    return () => timerRef.current && clearInterval(timerRef.current);
  }, []);

  const renderResendContent = () => {
    if (resendLoading) {
      return (
        <>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="otp-spinner" />
          <span> Sending...</span>
        </>
      );
    }
    if (secondsLeft > 0) {
      return <span className="resend-timer">Resend in {secondsLeft}s</span>;
    }
    return <span>Resend Code</span>;
  };

  return (
    <div className="enable-mfa d-flex flex-column">
      {auth?.isNonUKNumber === false ? (
        <>
          <span className="enable-mfa-desc-1">
            To help keep your account safe, we're now asking all customers to
            turn on Multi-Factor Authentication (MFA).
          </span>

          <span className="enable-mfa-desc-2">
            By adding this extra security step, your account will be even more
            protected. Simply provide your phone number, and we'll send you a
            quick verification code to complete the setup.
          </span>
        </>
      ) : otpSentByEmail !== true ? (
        <span className="enable-mfa-desc-1 mb-10">
          No problem, we’ll verify your account by email instead. Please be
          aware that, to register a test, you’ll still need to provide a valid
          phone number with the correct country code. This is important so our
          medical team can contact you to discuss your results if needed.
          <br />
          <br />
          Please note that our medical team may not be able to call all non-UK
          phone numbers directly.
        </span>
      ) : (
        <span>
          We've sent a verification code to{" "}
          <span className="mfa-email-text">
            {sessionStorage.getItem("email")}
          </span>
        </span>
      )}
      {transitioning ? (
        <div className="text-center">
          <Spinner
            animation="border"
            variant="info"
            className="my-custom-spinner"
          />
        </div>
      ) : (auth?.isNonUKNumber === false && isOtpStage !== true) ? (
        <DynamicForm
          key="mfa-phone-form"
          formikRef={addNumberformikRef}
          fields={
            isOtpStage
              ? OtpFields
              : MfaFields.map(field =>
                  field.name === "primary_contact_no"
                    ? { ...field, disabled: isUkNumberPrefilled, readOnly: isUkNumberPrefilled, allowNumberTypeSwitch: true }
                    : field
                )
          }
          onSubmit={handleMFASubmit}
          initialValues={{
            primary_contact_no: removeCountryCodeForUkNumber(ph_number),
            primary_contact_no_type: "phone",
          }}
          validationSchema={isOtpStage ? optSchema : mfaSchema}
          validationError={
            serverError
              ? "Unable to enable MFA for this account. Please try again later."
              : ""
          }
          validateOnChange
          validateOnBlur
        />
      ) : (
        !isOtpStage && (
          <DynamicForm
            key="mfa-email-form"
            fields={MfaEmailFields}
            onSubmit={handleMFASubmit}
            serverError={serverError}
            formikRef={addNumberformikRef}
            successClass={successClass}
            initialValues={{
              ...mfaValues,
              mfa_email: sessionStorage.getItem("email") || "",
              primary_contact_no: auth.primaryPhoneNumber || "",
              primary_contact_no_type: "advancePhoneNumber",
            }}
            validateOnChange
            validateOnBlur
          />
        )
      )}
      {isOtpStage && (
        <div className="otp-resend-section" style={{ paddingTop: 0 }}>
          <p className="otp-resend-text text-muted ageo-medium mb-0">
            <PhoneNumberForm
              optFields={isOtpStage}
              onSubmit={handleMFASubmit}
              serverError={serverError}
              formikRef={addNumberformikRef}
              successClass={successClass}
              initialValues={mfaValues}
            />
            Didn't receive the code?
            <button
              type="button"
              onClick={handleResendOtp}
              disabled={resendLoading || secondsLeft > 0}
              className="otp-resend-btn px-0 mx-1 ageo-semibold"
            >
              {renderResendContent()}
            </button>
          </p>
        </div>
      )}
      {(serverError || resendError) && (
        <span className="d-none">{serverError || resendError}</span>
      )}
    </div>
  );
};

export default EnableMFA;